import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=47f230c4"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports